import { SearchNormal1 } from 'iconsax-react';
import PropTypes from 'prop-types';
import { useState } from 'react';
import Text from '../../assets/styles/Text';
import PopUpSearch from '../PopUpSearch';
import * as styles from './styles';

export default function Search({ small = false, mobile = false }) {
  const [show, setShow] = useState(false);

  return (
    <styles.Container $small={small} $mobile={mobile}>
      <button type="button" onClick={() => setShow(true)}>
        <div>
          <SearchNormal1 />
        </div>

        {small ? (
          <Text.Span>PESQUISE POR CIDADE</Text.Span>
        ) : (
          <Text.P>PESQUISE POR CIDADE</Text.P>
        )}
      </button>

      <PopUpSearch show={show} onHideWindow={() => setShow(false)} />
    </styles.Container>
  );
}

Search.propTypes = {
  small: PropTypes.bool,
  mobile: PropTypes.bool,
};
